import { useState } from 'react'

const useManualShare = () => {
	const [isManualShareShown, setIsManualShareShown] = useState(false)

	const toggleNavShareShow = () => {
		setIsManualShareShown((prevState) => !prevState)
	}

	const closeNavShare = () => {
		setIsManualShareShown(false)
	}

	return { isManualShareShown, toggleNavShareShow, closeNavShare }
}

export default useManualShare
